var React = require('react');

function Logout (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M57 28.873H20.18m8.765 9l-8.765-8.999 8.765-8.999m24.678 21.941c-5.393 11.22-17.677 17.235-29.709 14.547S3.236 42.984 3.005 30.506 11.017 7.018 22.941 3.874s24.423 2.401 30.227 13.408"}));
}

Logout.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","fill":"none"};

module.exports = Logout;

Logout.default = Logout;
